import { SettingsSection } from '@/modules/external/components/customer/settings/settings-section.component';
import { useTranslation } from 'react-i18next';
import { MyDataComponent } from '../../components/customer/account/my-data.component';

export function SettingsProfilePage() {
  const { t } = useTranslation('customer');

  return (
    <SettingsSection
      title={t('settings.profile.title')}
      description={t('settings.profile.description')}
    >
      <MyDataComponent />
    </SettingsSection>
  );
}
